import { render, staticRenderFns } from "./entry-approval-details.vue?vue&type=template&id=4f150c46&scoped=true"
import script from "./entry-approval-details.vue?vue&type=script&lang=js"
export * from "./entry-approval-details.vue?vue&type=script&lang=js"
import style0 from "./entry-approval-details.vue?vue&type=style&index=0&id=4f150c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f150c46",
  null
  
)

export default component.exports